/**
 * @description - Fungsi untuk membangun query string dari parameter baru dan parameter saat ini.
 * @param {Object} newParams - Parameter baru.
 * @param {Object} currentQueries - Parameter saat ini.
 * @returns {String} - Query string.
 */
const buildQueryString = (newParams = {}, currentQueries = {}) => {
  const currentQuery = { ...currentQueries }

  Object.keys(newParams).forEach(key => {
    const val = newParams[key]
    if (val === null || val === undefined || val === '') {
      delete currentQuery[key]
    } else {
      currentQuery[key] = val
    }
  })

  const validKeys = Object.keys(currentQuery).filter(
    key => currentQuery[key] !== null && currentQuery[key] !== undefined && currentQuery[key] !== '',
  )

  if (validKeys.length === 0) return ''

  const queryString = validKeys
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(currentQuery[key])}`)
    .join('&')
  return `?${queryString}`
}

export default buildQueryString
